module.exports = __webpack_public_path__ + "img/no.b48f5c07.png";